<template>
  <div id="personalUpdata">
  <mt-header :title="titleneme"  fixed>
		  <a href="javascript:void(0)" slot="left" @click="returnBack">
		    <mt-button icon="back" class="font-Yahei"></mt-button>
		  </a>
		  <a href="/" slot="right">
		    <mt-button><img src="../../../static/images/go_home_ico.png" width="23"/></mt-button>
		  </a>
	</mt-header>
	<div class="mt40">
		<div class="nickname" v-if="showType==0">
	     <mt-field label="昵称" placeholder="请输入昵称" v-model="nickname" :attr="{ maxlength: 10 }" class="border-bottom-line"></mt-field>
	     <p class="ml103 colorccc mt5">注：仅支持中文、英文、数字</p>
	     <p class="precent80 mt40"><input type="button" value="保存" class="btnLogin" @click="saveByname"/></p>
		</div>
		<div class="email" v-if="showType==1">
		 <mt-field label="邮箱" placeholder="请输入邮箱" v-model="email" :attr="{ maxlength: 50 }" class="border-bottom-line"></mt-field>
	     <p class="precent80"><input type="button" value="保存" class="btnLogin" @click="saveByEmail"/></p>
		</div>		
		<div class="phonenumwrap" v-if="showType==2">
			<!--获取验证码-->
			<div v-show="!showsetmmpage">
				<p class="mb30 color333 font-size9 text-center">当前绑定的手机号是：{{usernamem}}</p>
				<div class="login_line1">
					<i class="logIco"><img src="../../../static/images/phone_ico.png"/></i>
					<input type="number" placeholder="手机验证码" v-model="vcode" maxlength="6" @input="vcodecheck1"/>
					<button class="btnSend" @click="sendCode" :disabled="disabled">
					   <span v-if="sendMsgDisabled">{{time+'秒后获取'}}</span>
		         <span v-if="!sendMsgDisabled">发送验证码</span>
					</button>
				</div> 
		    <!--<p class="precent80"><input type="button" value="保存" class="btnLogin" @click="saveByEmail"/></p>-->
		    <p class="pt5"><input type="button" value="下一步" @click="btnRegnext" class="btnReg" :class="{disableColor:checkeds==false}"  :disabled="disabledss"/></p>
	    </div>
	    <!--更换手机号获取验证码-->
	    <div v-show="showsetmmpage">
					<div class="login_line">
						<i class="logIco"><img src="../../../static/images/my_ico.png"/></i>
						<input type="tel" placeholder="新绑定手机号" maxlength="11" v-model="newphone" @input="vcodecheck"/>
					</div>
					<div class="login_line">
						<i class="logIco"><img src="../../../static/images/phone_ico.png"/></i>
						<input type="number" placeholder="手机验证码" v-model="newphonevcode" maxlength="6" @input="vcodecheck"/>
						<button class="btnSend" @click="send" :disabled="disabled2">
						   <span v-if="sendMsgDisabled2">{{time2+'秒后获取'}}</span>
			          <span v-if="!sendMsgDisabled2">发送验证码</span>
						</button>
					</div>
					<p class="font-size6 colere24b0f text-center">更换绑定手机号后,原手机号码将不能作为登录凭证</p>
					<p><input type="button" value="确认更换" class="btnLogin" :class="{disableColor:disableds==true}" @click="btnLogin" :disabled="disableds"/></p>
					<!--<p class="loging_p"><router-link to="/Register" class="regText">注册账号</router-link><span class="regText" @click="Toaccount">账号密码登录</span></p>-->
				</div>
			</div>
	</div>
  </div>
</template>

<script>
	import { Toast } from 'mint-ui'
  import { Indicator } from 'mint-ui'
  export default{
		data(){
			return{
				 username:localStorage.getItem("username"),   //用户名
				 titleneme:this.$route.query.titleneme,
			   nickname:this.$route.query.content,
			   email:this.$route.query.content,
			   showType:this.$route.query.type,
			   time: 60, // 发送验证码倒计时
			   time2: 60, // 发送验证码倒计时
         sendMsgDisabled: false,
         sendMsgDisabled2: false,
         disabled:false,
         disabled2:false,
         phone:"",
         vcode:"",
         checkeds:false,
         disabledss:true,
         disableds:true,
         showsetmmpage:false,  //更换手机号默认页面
//       showsetmmpage:true,
         newphone:"",  //新绑定手机号
         newphonevcode:"", //更换手机号的验证码
         md5sign:this.Act_md5sign,
			}
		},
		computed:{
			 usernamem:function(){
			 	 return this.username.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
			 }
		},
    methods: {
       returnBack(){
       	 this.$router.go(-1);
       },  
       saveByname(){
       	 if(this.validateNick()){
       	 	  this.$http.post(this.URL_PREFIX+"/user/saveUserData.net",{uName:this.username,name:this.nickname})
		  	    .then((res) =>{
		  	      if(res.data.code==200){
		  	      	 Toast(res.data.msg);
		  	      	 this.$router.go(-1)
		  	      }else{
		  	      	 Toast(res.data.msg);
		  	      }     
		  	    });
       	 }       
       },
       vcodecheck1(){
	    		if(this.vcode.length>5){
	    			this.checkeds=true;
	    			this.disabledss=false;
	    		}else{
	    			this.checkeds=false;
	    			this.disabledss=true;
	    		}
	    	},
       vcodecheck(){
	    		if(this.newphonevcode.length>5&&this.newphone.length==11){
	    			this.disableds=false;
	    		}else{
	    			this.disableds=true;
	    		}
	    	},
       saveByEmail(){
       	 if(this.validateEmail()){
       	 	  this.$http.post(this.URL_PREFIX+"/user/saveUserData.net",{uName:this.username,email:this.email})
		  	    .then((res) =>{
		  	      if(res.data.code==200){
		  	      	 Toast(res.data.msg);
		  	      	 this.$router.go(-1);
		  	      }else{
		  	      	 Toast(res.data.msg);
		  	      }
		  	    });
       	 }
       },
       //下一步按钮
	     	btnRegnext(){
	     	  if(this.vcode==""){
	     	  	 Toast("请输入手机验证码");
	     	  }else{
	     	  	this.$http.post(this.URL_PREFIX+"/user/updateBindPhone.net",{oldPhone:this.username,verCode:this.vcode})
			  	.then((res) =>{
			  	    if(res.data.code==200){
			  	    	this.showsetmmpage=true;
			  	       Toast(res.data.msg);
//			  	       localStorage.setItem('username',this.phone);
//			  	       this.$router.push(this.$route.query.redirect || '/');
                  
			  	    }else{
			  	       Toast(res.data.msg);
			  	    }  
			  	});
	     	  }
	     	},
	     	//验证用户是否已经注册
	     	send(){
	     		this.$http.post(this.URL_PREFIX+"/user/userIsExistence.net",{phone:this.newphone})
				 .then((res) =>{
				 	if(res.data.code!=200){
				 	   this.userconfire();
				 	}else{
				 		Toast("该手机号已被绑定");	  
				 	}
				});
	     	},
	     	//新手机号获取验证码
	     	userconfire(){
	     		var signM=md5('phone_num='+this.newphone+'&'+this.md5sign);
	     		if(this.validatePhone()){
	     			Indicator.open();     		
		     		this.$http.post(this.URL_PREFIX+"/user/sendVerCode.net",{phone_num:this.newphone,codeType:1,sign:signM})
					 .then((res) =>{
					 	Indicator.close();
					 	if(res.data.code!=200){
					 	  Toast(res.data.msg);
					 	}else{
					 	  Toast(res.data.msg);
					 	  let me = this;
					        me.sendMsgDisabled2 = true;
					        me.disabled2=true;
					        let interval = window.setInterval(function(){
					          if ((me.time2--) <= 0) {
					            me.time2 = 60;
					            me.sendMsgDisabled2 = false;
					            me.disabled2=false;
					            window.clearInterval(interval);
					           }
					    }, 1000);
					 	}
					});
				}
	     	},
       //发送验证码按钮
	     	sendCode(){
	     		  var signM=md5('phone_num='+this.username+'&'+this.md5sign);
	     			Indicator.open();
			      this.$http.post(this.URL_PREFIX+"/user/sendVerCode.net",{phone_num:this.username,codeType:1,sign:signM})
				  	.then((res) =>{
				  		Indicator.close();
				  		if(res.data.code!=200){
				  			Toast(res.data.msg);
				  		}else{
				  			Toast(res.data.msg);
				  			let me = this;
					        me.sendMsgDisabled = true;
					        me.disabled=true;
					        let interval = window.setInterval(function(){
					          if ((me.time--) <= 0) {
					            me.time = 60;
					            me.sendMsgDisabled = false;
					            me.disabled=false;
					            window.clearInterval(interval);
					           }
					        }, 1000);
						    }
				  	});
	     	},
       //昵称验证
       validateNick(){
       	var reg=/^[\u4E00-\u9FA5A-Za-z0-9]+$/;
       	if(this.nickname==""){
       		Toast("请输入昵称");
          return false;
       	}else if(!reg.test(this.nickname)){
       		Toast("昵称格式错误");
          return false;
       	}else{
       		return true;
       	}
       },
       //更换手机号确认更换
	     	btnLogin(){
	     	  if(this.validatePhone()){
	     		  if(this.newphonevcode==""){
	     		  	  Toast("请输入手机验证码");
	     		  }else{
	     		  	this.$http.post(this.URL_PREFIX+"/user/updateBindPhone.net",{oldPhone:this.username,verCode:this.newphonevcode,newPhone:this.newphone})
				  	.then((res) =>{
				  	    if(res.data.code==200){
				  	    	Toast(res.data.msg);
				  	    	this.userlogin(res.data.obj.uName);
				  	    }else{
				  	       Toast(res.data.msg);
				  	    }
				  	});
	     		  }
	     		}
	     	},
	     	//验证用户登录
	     	userlogin(hpone){
	     		this.$http.post(this.URL_PREFIX+"/user/isUserLogin.net",{phone:hpone})
				  	.then((res) =>{
				  	    if(res.data.code==200){
				  	       localStorage.setItem("username",res.data.obj);
				  	       if(this.$route.query.redirect=="payState.html"){
	              	 	  	 location.href="http://m.vcard8.com/payState.html";
	              	 	   }else{
	              	 	   	 this.$router.push({path:"/UserCenter"});
	              	 	   }
				  	    }else{
				  	       Toast(res.data.msg);
				  	    }
				  	});
	     	},	     	
	      //手机号验证
	     	validatePhone(){
	     		var reg=/^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;;
	     		if(this.newphone==''){
                    Toast("请输入新绑定手机号码");
                   return false;
                }else if(!reg.test(this.newphone)){
                    Toast("手机号格式不正确");
                    return false;
                }else{
                	  return true;
                }
	     	},
       //邮箱验证
       validateEmail(){
     		 var reg=/^[A-Za-z0-9-_]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9]+)+$/;
       	 if(this.email==''){
            Toast("请输入邮箱");
            return false;
        }else if(!reg.test(this.email)){
            Toast("邮箱格式不正确");
            return false;
        }else{
          return true;
        }
     	}
    }
	}
</script>

<style scoped="scoped">
/*@import "../../../static/css/user.css";*/
.phonenumwrap{width: 85%;margin: 100px auto 45px;}
.login_line1{border-bottom: 1px solid #e0e0e0;padding: 10px;margin-bottom: 10px;overflow: hidden;}
.login_line1 input{width: 48%;color: #333;font-size: 1rem;border: none;background: transparent;float: left;line-height: 30px;margin-left: 20px;}
.login_line{border: 1px solid #e0e0e0;padding: 10px;margin-bottom: 10px;overflow: hidden;border-radius: 5px;-webkit-border-radius: 5px;}
.login_line input{width: 48%;color: #333;font-size: 1rem;border: none;background: transparent;float: left;line-height: 30px;margin-left: 20px;}
.logIco{width: 26px;height: 26px;float: left;margin-top: 3px;}
.logIco img,.partyLogin span img{width: 100%;}
.btnLogin,.btnRegOk,.btnReg{width: 100%;height: 40px;background: #ff8920;color: #fff;font-size: 1.0rem;border-radius: 5px;-webkit-border-radius: 5px;margin-top:15px;border: none;line-height: 40px;}
.btnSend{float: right;border: none;background: transparent;line-height: 32px;color: #999;font-size: 0.8rem;}
.btnLogin.disableColor,.btnRegOk.disableColor,.btnReg.disableColor{background-color:#F8B377;}

/*.loginContent{width: 85%;margin: 45px auto;}
.login_line2{border: 1px solid #e0e0e0;padding: 10px;margin-bottom: 10px;overflow: hidden;border-radius: 5px;-webkit-border-radius: 5px;display: flex;}
.login_line2 input{width: 100%;color: #333;font-size: 1.0rem;border: none;background: transparent;line-height: 30px;margin-left: 20px;}
.login_line2 .logIco{width: 26px;height: 26px;margin-top: 3px;}
.btnSend{float: right;border: none;background: transparent;line-height: 32px;color: #999;font-size: 0.8rem;}*/

.precent80{width: 90%;margin: 10px auto;}
.ml103{margin-left: 103px;}
.colere24b0f{color: #e24b0f;}
</style>


// WEBPACK FOOTER //
// src/views/UserCenter/personalUpdata.vue